import classNames from "classnames/bind";
import Button from "common/blocks/Button";
import DynamicPhoneNumber from "common/blocks/DynamicPhoneNumber";
import Info from "common/blocks/Info";
import UIIcon from "common/blocks/UIIcon";
import { PartExchangeQuestions } from "services/motorpoint/partExchangeQuestions";

import styles from "./TooUnique.module.scss";

const cx = classNames.bind(styles);

const TooUnique = ({
    tooUnique,
    closeModal,
    onValueNewVehicle,
}: {
    onValueNewVehicle(): void;
    closeModal: (avoidCallback?: boolean) => void;
    tooUnique: PartExchangeQuestions.TooUnique;
}) => {
    return (
        <div className={cx("partExchangeWrapper")}>
            <div className={cx("error")}>
                <Info>
                    <span
                        dangerouslySetInnerHTML={{
                            __html: tooUnique.Message,
                        }}
                    />
                </Info>
                <div className={cx("contactDetails")}>
                    <UIIcon icon="Tel" className={cx("phoneIcon")} />
                    <DynamicPhoneNumber isLink />
                </div>
            </div>
            <Button
                theme="primary"
                type="button"
                fullWidth
                onClick={() => closeModal()}
                ariaLabel="Done"
            >
                Done
            </Button>
            <Button
                theme="secondary"
                type="button"
                fullWidth
                onClick={onValueNewVehicle}
                ariaLabel="Value new vehicle"
            >
                Value new vehicle
            </Button>
        </div>
    );
};

export default TooUnique;
